module.exports = __webpack_public_path__ + "static/media/16UNODC7.2619d6d0.jpg";